import type { Party } from "@/types/ui-models";
import { dash } from "../lib/partyUtils";
import PartyStatusBadge from "./PartyStatusBadge";
import PartyTypeBadge from "./PartyTypeBadge";

interface PartyCardProps {
  party: Party;
  onView: (party: Party) => void;
}

export default function PartyCard({ party, onView }: PartyCardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 hover:border-background-300 transition-colors flex flex-col">
      <div className="flex items-start justify-between mb-3">
        <PartyTypeBadge type={party.type} />
        <PartyStatusBadge status={party.status} />
      </div>
      <h4 className="text-sm font-semibold text-foreground-900 mb-1 truncate font-heading">{party.name}</h4>
      {party.institution && (
        <p className="text-xs text-foreground-400 mb-2">{party.institution}</p>
      )}
      <p className="text-xs text-foreground-500 mb-3">{dash(party.primaryRole)}</p>
      <div className="flex items-center gap-4 text-xs text-foreground-500 mb-3">
        <span className="flex items-center gap-1">
          <i className="ri-mail-line w-3.5 h-3.5 flex items-center justify-center" />
          {dash(party.email)}
        </span>
        <span className="flex items-center gap-1">
          <i className="ri-phone-line w-3.5 h-3.5 flex items-center justify-center" />
          {dash(party.phone)}
        </span>
      </div>
      <div className="flex items-center gap-3 text-xs text-foreground-500 mb-4">
        <span className="flex items-center gap-1">
          <i className="ri-link-m w-3.5 h-3.5 flex items-center justify-center" />
          <strong className={party.activeLinks > 0 ? "text-primary-600" : "text-foreground-400"}>{party.activeLinks}</strong> vínculos
        </span>
        <span className="flex items-center gap-1">
          <i className={`${party.hasDocuments ? "ri-file-list-3-line text-primary-500" : "ri-file-list-3-line text-foreground-300"} w-3.5 h-3.5 flex items-center justify-center`} />
          {party.hasDocuments ? "Com docs" : "Sem docs"}
        </span>
      </div>
      <div className="flex gap-2 mt-auto">
        <button
          onClick={() => onView(party)}
          className="flex-1 px-3 py-2 text-xs font-medium text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
        >
          <i className="ri-eye-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1" />
          Visualizar
        </button>
      </div>
    </div>
  );
}